module.exports = __webpack_public_path__ + "img/content-14@2x.343253c.png";